var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneSolid = function SvgPhoneSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.2 4.8a1.6 1.6 0 0 1 1.6-1.6h3.445a1.6 1.6 0 0 1 1.578 1.337l1.183 7.097a1.6 1.6 0 0 1-.863 1.694l-2.477 1.239a17.66 17.66 0 0 0 9.767 9.767l1.239-2.477a1.6 1.6 0 0 1 1.694-.863l7.097 1.183a1.6 1.6 0 0 1 1.337 1.578V27.2a1.6 1.6 0 0 1-1.6 1.6H24C12.512 28.8 3.2 19.488 3.2 8z"
  })));
};
export default SvgPhoneSolid;